import { makeAutoObservable } from 'mobx'

import { IExcursionsOrder } from './model'

const default_people_quantity = 1

const default_total_price = 1

interface PurchaseExcursions {
  first_name: string
  last_name: string
  phone: string
  email: string
}

const initialState: IExcursionsOrder = {
  people_quantity: default_people_quantity,
  total_price: default_total_price,
  client_first_name: '',
  client_last_name: '',
  client_email: '',
  client_phone: '',
  excursion_id: '',
  bonus_amount: '',
  tranche_amount: '',
  is_bonus: false,
}

class OrderExcursionsStore {
  orderExcursionInfo: IExcursionsOrder = initialState

  constructor() {
    makeAutoObservable(this)
  }

  onPeopleQuantityChange(quantity: number) {
    this.orderExcursionInfo.people_quantity = quantity
  }
  onTotalPriceChange(price: number, trancheAmount?: string) {
    this.orderExcursionInfo.total_price = price

    if (trancheAmount) {
      this.orderExcursionInfo.tranche_amount = trancheAmount
    }
  }

  onChangeFormData(form: PurchaseExcursions) {
    this.orderExcursionInfo = { ...this.orderExcursionInfo, ...form }
  }

  onChangeExcursionId(id: string) {
    this.orderExcursionInfo.excursion_id = id
  }

  onChangeBonus(is_bonus: boolean, bonus_amount: string) {
    this.orderExcursionInfo = {
      ...this.orderExcursionInfo,
      is_bonus,
      bonus_amount,
    }
  }
}

export const orderExcursionsStore = new OrderExcursionsStore()
